const confjs = {
    tagname : "hellowork"
}

const hw = {
    baseRessourcesUrl: '',
    getBaseRessourcesUrl() {
        if (hw.baseRessourcesUrl === '') {
            let script = document.querySelector('script[src*="/' + confjs.tagname + '/"]') as HTMLScriptElement;    
            if (!script) {
                script = document.querySelector('script[src*="/js/"]');
            }
            if (script) {
                const scriptArrray = script.src.split("/");
                scriptArrray.pop();
                scriptArrray.pop();
                hw.baseRessourcesUrl = scriptArrray.join("/");
                return hw.baseRessourcesUrl
            }
           
        }
        return hw.baseRessourcesUrl;
    }
}

export {
    confjs,
    hw
}